import React, { useState, useEffect } from 'react';
import cssClasses from './WingWiseBookingForSalesManagerDetailsModal.module.css';
import { Box, IconButton, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Button from '../../../../Subcomponents/Button';
import { groupBy } from 'lodash';

function WingWiseBookingForSalesManagerDetailsModal({open, handleClose, wingWiseBookingDataForSalesManagerForModal}) {

  const [salesData, setSalesData] = useState(null);

  useEffect(() => {
    console.log("wingWiseBookingDataForSalesManagerForModal => ", wingWiseBookingDataForSalesManagerForModal);
    let data = groupBy(wingWiseBookingDataForSalesManagerForModal, allotmentPaymentItem => allotmentPaymentItem?.unitId?.inventoryTypeId?.type);

    console.log(data);
    setSalesData(data);
  }, [wingWiseBookingDataForSalesManagerForModal])
  

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={[{
        ".MuiBackdrop-root":{
          background: "rgba(193, 201, 210, 0.7)"
        }
      }]}
      disableAutoFocus={true}
    >
      <Box className={cssClasses.modalWrapper}>
        <div className={cssClasses.header}>
          {/* <img src={MessageIcon} alt="" /> */}
          <h1>Wing Inventory Details </h1>
          {/* <img src={crossImage} alt="" style={{cursor:"pointer"}} onClick={handleClose}/> */}
          <IconButton className={cssClasses.crossButton} onClick={handleClose}> <CloseIcon /> </IconButton>
        </div>

        <div className={cssClasses.mainContainer}>
          <TableContainer style={{overflow: "auto"}}>
            <Table stickyHeader sx={[tableStyle]}>
                <TableHead>
                    <TableRow>
                        <TableCell>Unit&nbsp;Type</TableCell>
                        <TableCell align="right">Available</TableCell>
                        <TableCell align="right">Sold</TableCell>
                        <TableCell align="right">Total Sales</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {salesData && Object.keys(salesData).map((salesNameKey) => (
                        <TableRow key={salesNameKey} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell component="th" scope="row">{salesNameKey}</TableCell>
                            <TableCell align="right">
                              {
                                salesData[salesNameKey]?.filter(f => ["Available"].some(s => s === f?.unitId?.inventoryStatusId?.status))?.length || 0
                              }
                            </TableCell>
                            <TableCell align="right">
                              {
                                salesData[salesNameKey]?.filter(f => ["On Hold", "Preselected", "Sold", "Payment Pending", "Kyc Pending"  , "Kyc Done"].some(s => s === f?.unitId?.inventoryStatusId?.status))?.length || 0
                              }
                            </TableCell>
                            <TableCell align="right">
                              ₹ {
                                numDifferentiation(salesData[salesNameKey]?.filter(f => ["On Hold", "Preselected", "Sold", "Payment Pending", "Kyc Pending" , "Kyc Done"].some(s => s === f?.unitId?.inventoryStatusId?.status))?.map(item => item?.unitId?.BSP)?.reduce((prev, next) => prev + next, 0) || 0)
                              }
                            </TableCell>
                            {/* <TableCell align="right"><Typography color={"#374151"} fontSize={"1.6rem"} lineHeight={"3rem"} fontWeight={700} textAlign={"center"} style={{cursor: "pointer"}} component={"u"}>View&nbsp;Details</Typography></TableCell> */}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
          </TableContainer>
        </div>

        <div className={cssClasses.footer}>
          {/* <div><Button style={{ color: "#7F56D9", backgroundColor: "#ffffff" }} btnName={"Download PDF"} clicked={handleClose} /></div> */}
          <div><Button style={{ color: "#344054", backgroundColor: "#ffffff" }} btnName={"Close"} clicked={handleClose} /></div>
          {/* <div><Button style={{ color: "#ffffff", backgroundColor: "#155EEF" }} btnName={"Submit"} disable={!Boolean(selectedCrmUser)} clicked={submitHandler}/></div> */}
        </div>
      </Box>
    </Modal>
  )
}

export default WingWiseBookingForSalesManagerDetailsModal;
const labelStyle = {
  fontWeight: "500",
  fontSize: "14px",
  lineHeight: "20px",
  color: "#344054",
  marginBottom: "0.8rem"
}
const tableStyle = {
  ' .MuiTableCell-root': {
      fontSize: "1.6rem"
  }
}
function numDifferentiation(value) {
  const val = Math.abs(value)
  if (val >= 10000000) return `${(value / 10000000).toFixed(2)} Cr`
  if (val >= 100000) return `${(value / 100000).toFixed(2)} Lac`
  return value;
}